import { render, staticRenderFns } from "./SaldoChecker.vue?vue&type=template&id=df897bbc&scoped=true&"
import script from "./SaldoChecker.vue?vue&type=script&lang=js&"
export * from "./SaldoChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df897bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df897bbc')) {
      api.createRecord('df897bbc', component.options)
    } else {
      api.reload('df897bbc', component.options)
    }
    module.hot.accept("./SaldoChecker.vue?vue&type=template&id=df897bbc&scoped=true&", function () {
      api.rerender('df897bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/SaldoChecker.vue"
export default component.exports